<template>
    <v-bottom-navigation class="bottomNavigation"
                         fixed
                         horizontal
                         elevation="0"
                         height="70"
    >
      <v-btn class="bottom-nav__btn" @click="this.forwardToCategories">
        <span>Artikel&shy;kategorien</span>
        <div class="pr-2">
          <category/>
        </div>
      </v-btn>

      <v-btn class="bottom-nav__btn" @click="this.forwardToWatchlist">
        <span>Gemerkte Artikel</span>
        <div class="pr-2">
          <notes/>
        </div>
      </v-btn>

      <div class="bottom-nav__scan_div">
        <v-btn class="bottom-nav_scan_btn"
               fab
               x-small
               @click="this.setBarcodeScannerState"
        >
          <scanBtn/>
        </v-btn>
      </div>
      <bg class="bottomBackground"/>

      <v-fade-transition>
        <v-btn fab
               class="scrollTopBottomBtn"
               v-if="getTopScroll"
               @click="scrollToTop"
        >
          <chevron_up/>
        </v-btn>
      </v-fade-transition>

    </v-bottom-navigation>
</template>

<script>
import {mapActions, mapMutations, mapGetters} from 'vuex'
import Notes from "@/assets/navigation/notes";
import Category from "@/assets/navigation/category";
import Bg from "@/assets/bg";
import ScanBtn from "@/assets/navigation/scanBtn";
import chevron_up from "@/assets/chevron/chevron_up";
import router from "@/router";

export default {
  name: "bottomNavigation",
  components: {ScanBtn, Bg, Category, Notes, chevron_up},

  methods: {
    ...mapActions ({
      forwardToCategories: 'forwardToCategories',
      forwardToWatchlist: 'forwardToWatchlist'
    }),

    ...mapMutations({
      setBarcodeScannerState: 'setBarcodeScannerState',
      setTopScroll: 'setTopScroll'
    }),

    scrollToTop() {
      let route = router.currentRoute.name
      if(route === 'LastArticle') {
        let el = document.getElementById('headerCircle')
        el.scrollIntoView()
      }
      else if(route === 'Checkout') {
        let el = document.getElementById('contentWrapper')
        let offsetTop = el.offsetTop

        el.scrollTop = offsetTop -100
      }
    },
  },

  computed: {
    ...mapGetters({
      getTopScroll: 'getTopScroll'
    })
  }
}
</script>

<style>
  .scrollTopBottomBtn.v-btn {
    position: absolute!important;
    background-color: var(--igros-red) !important;
    bottom: 120px;
    right: 5px;
    height: 44px!important;
    width: 44px!important;
    min-width: 44px!important;
    border-radius: 30px!important;
  }
</style>
